export namespace DisplayPaint {
    export const strokeStyle = (opacity: number = 0.75) => `hsla(200, 83%, 60%, ${opacity})`
}